<template>
  <div>
    <div>
      <el-card>
        <span style="font-style: italic; font-weight: bold; color: #0a8700">{{ categories[category_id] }}</span>
        <!--        <span style="color: #0a8700;font-weight: bold"> For the Fiscal Year-->
        <!--          <el-select-->
        <!--            v-model="filterYear"-->
        <!--            class="ssearch"-->
        <!--            size="small"-->
        <!--          >-->
        <!--            <el-option-->
        <!--              v-for="type in yearArray"-->
        <!--              :key="type.year"-->
        <!--              :label="type.year"-->
        <!--              :value="type.year"-->
        <!--            />-->
        <!--          </el-select>-->
        <!--        </span>-->
      </el-card>
      <div v-loading="category_load" class="content-tabs">
        <el-tabs v-model="activeTabName" tab-position="top" type="border-card" class="outer-tabs" @tab-click="setActiveTabName(activeTabName, $event.index)" >
          <el-tab-pane v-for="tab in tabs" :label="tab.name" :name="'' + tab.id" :key="tab.id">
            <el-alert
              :closable="false"
              :title="clause_info"
              type="info"
              show-icon
            />
            <el-tabs v-model="activeProcessTab" class="inner-tabs" tab-position="left" @tab-click="setActiveProcessTab(activeProcessTab, $event.label, $event.index)">
              <el-tab-pane v-for="ptab in processTabs" :label="ptab.name" :name="'' + ptab.id" :key="ptab.id">
                <div v-if="( (ptab.id).toString() === activeProcessTab)">
                  <div v-loading="loading" v-if="!showTable && (ptab.id).toString() === activeProcessTab">
                    <el-row>
                      <el-col :lg="8" :md="8" :sm="8" style="text-align: center">
                        <span style="float: left; padding-left: 20px; padding-top: 15px; padding-bottom: 10px"><a v-if="visibleNewFolder" style="color: #0a8700" @click="newFolder(true)"><i class="fas fa-folder-plus"/> new folder</a></span>
                      </el-col>
                      <el-col :lg="8" :md="8" :sm="8">
                        <div style="padding-top: 20px; text-align: center; font-style: italic; font-weight: bold; color: #0a8700"><span >{{ titletab }}</span></div>
                      </el-col>
                    </el-row>
                    <hr>
                    <el-row>
                      <el-col :lg="4" :md="4">
                        <br>
                        <span style="padding-left: 20px;">
                          <el-input
                            v-debounce="getDirectory"
                            :debounce-events="'keydown'"
                            v-model="folder_search"
                            placeholder="Type something">
                            <i slot="prefix" class="el-input__icon el-icon-search"/>
                          </el-input>
                        </span>
                      </el-col>
                      <el-col v-if="disableFilter" :lg="4" :md="4" >
                        <br>
                        <span style="padding-left: 20px;">
                          <select-department v-model="filter_dept_id" @setDepartment="filter_dept_id = $event"/>
                        </span>
                      </el-col>
                      <el-col :lg="4" :md="4">
                        <br>
                        <span style="padding-left: 20px;">
                          <el-select v-model="docu_type_id" :remote-method="getDocutype" :remote="true" filterable clearable placeholder="Select Folder Type">
                            <el-option v-for="doc in docu_types" :key="doc.id" :value="doc.id" :label="doc.name">{{ doc.name }}</el-option>
                          </el-select>
                        </span>
                      </el-col>
                    </el-row>
                    <el-row v-if="meta.total <= 0">
                      <el-col :lg="24" :md="24" :sm="24" style="text-align: center; color: slategrey; font-style: italic">
                        <p>no data found</p>
                      </el-col>
                    </el-row>
                    <br>
                    <el-row :key="process_id" style="min-height: 40vh;">
                      <el-col v-for="directory in directories" :key="directory.id" :xs="24" :sm="24" :md="24" :lg="4">
                        <div style="height: 28vh">
                          <div>
                            <a @click="opentable(true, directory.id, directory)">
                              <el-card :body-style="{ padding: '0px' }" shadow="hover" style="margin-right: 15px;margin-bottom: 15px; height: 23vh !important;" >
                                <div style="text-align: center">
                                  <img v-if="directory.docutype_id === 1" src="../../../assets/1.png" style="width: 9vw" class="user-avatar center-logo">
                                  <img v-if="directory.docutype_id === 2" src="../../../assets/2.png" style="width: 9vw" class="user-avatar center-logo">
                                  <img v-if="directory.docutype_id === 3" src="../../../assets/3.png" style="width: 9vw" class="user-avatar center-logo">
                                  <img v-if="directory.docutype_id === 4" src="../../../assets/4.png" style="width: 9vw" class="user-avatar center-logo">
                                  <img v-if="directory.docutype_id > 4" src="../../../assets/QMSFolder.png" style="width: 9vw" class="user-avatar center-logo">
                                </div>
                                <div style="padding: 2px;height:90px;max-height: 100px;">
                                  <el-row>
                                    <el-col :lg="21" style="overflow: hidden;height: 50px;max-height: 50px;">
                                      <time>
                                        {{ directory.name }}
                                      </time>
                                    </el-col>
                                    <el-col v-if="directory.file_count > 0" :lg="3" style="font-size: 8px; color: #0a8700;">
                                      <time>
                                        <el-badge :value="directory.file_count " class="item" type="success"/>
                                      </time>
                                    </el-col>
                                    <el-col v-if="directory.dlink !== null" :lg="3" style="font-size: 12px; color: #0a8700">
                                      <time>
                                        <i class="fab fa-google-drive"/>
                                      </time>
                                    </el-col>
                                  </el-row>
                                  <el-row>
                                    <time class="time" style="cursor: pointer;">
                                      {{ directory.desc }}
                                    </time>
                                  </el-row>
                                </div>
                              </el-card>
                            </a>
                          </div>
                          <div>
                            <div v-if="check_directory_owner(directory.dept_id)" style="margin-top: -25px">
                              <el-button class="btn-edit" type="text" @click="editFolder(directory)">
                                <i class="fas fa-edit" />
                              </el-button>
                              <el-button class="btn-delete" type="text" @click="deleteFolder(directory)">
                                <i class="fas fa-trash" />
                              </el-button>
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                    <div v-if="meta.total >= 1" style="text-align: center; padding-bottom: 20px">
                      <el-pagination :page-size="meta.per_page" :pager-count="11" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getDirectory"/>
                    </div>
                  </div>
                  <div v-if="showTable && (ptab.id).toString() === activeProcessTab" :key="cnt">
                    <el-row>
                      <el-col :lg="8" :md="8" :sm="8" style="text-align: center">
                        <span style="float: left; padding-left: 20px; padding-top: 15px; padding-bottom: 10px"> <a @click="closeTable(false)"> <i class="fas fa-arrow-left"/> Back</a> | <span style="color: #0a8700"><i class="fas fa-folder-open"/> {{ selected.name }}</span></span>
                      </el-col>
                      <el-col :lg="8" :md="8" :sm="8">
                        <div style="padding-top: 20px; text-align: center; font-style: italic; font-weight: bold; color: #0a8700"><span >{{ titletab }}</span></div>
                      </el-col>
                      <el-col v-if="directory_owner" :lg="8" :md="8" :sm="8" >
                        <span style="float: right; padding-right: 20px; padding-top: 15px; padding-bottom: 10px"><a style="color: #0a8700" @click="newFile(true)"><i class="fas fa-file-alt"/> New File</a></span>
                      </el-col>
                    </el-row>
                    <hr>
                    <el-row>
                      <el-col :lg="4" :md="4">
                        <br>
                        <span style="padding-left: 20px;">
                          <el-input
                            v-debounce="getAllFiles"
                            :debounce-events="'keydown'"
                            v-model="search"
                            placeholder="Type something">
                            <i slot="prefix" class="el-input__icon el-icon-search"/>
                          </el-input>
                        </span>
                      </el-col>
                    </el-row>
                    <el-row v-if="files_meta.total <= 0">
                      <el-col :lg="24" :md="24" :sm="24" style="text-align: center; color: slategrey; font-style: italic">
                        <p>no files found</p>
                      </el-col>
                    </el-row>
                    <el-row v-loading="loading" :gutter="2" style="min-height: 20vw" >
                      <el-col v-for="file in files" :key="file.id" :xs="24" :sm="24" :md="24" :lg="4">
                        <br>
                        <div>
                          <a @click="previewfile(true, file, file.id)">
                            <el-card :body-style="{ padding: '0px' }" shadow="hover" style="margin-right: 15px;margin-bottom: 15px; height: 23vh !important;" >
                              <div style="text-align: center">
                                <br>
                                <i class="far fa-file" style="font-size: 5vw"/>
                              </div>
                              <div style="padding-top: 10px;">
                                <el-row>
                                  <el-col :span="18">
                                    <time>
                                      {{ file.name }}
                                    </time>
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <time class="time" style="cursor: pointer;">
                                    {{ file.desc }}
                                  </time>
                                </el-row>
                              </div>
                            </el-card>
                          </a>
                          <div v-if="directory_owner" style="margin-top: -20px">
                            <el-button class="btn-edit" type="text" @click="editFile(file)">
                              <i class="fas fa-edit" />
                            </el-button>
                            <el-button class="btn-delete" type="text" @click="deleteFile(file)">
                              <i class="fas fa-trash" />
                            </el-button>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                    <div v-if="files_meta.total >= 1" style="text-align: center; padding-bottom: 20px" >
                      <el-pagination :page-size="files_meta.per_page" :pager-count="11" :total="files_meta.total" :current-page.sync="files_meta.page" layout="total, prev, pager, next" @current-change="getAllFiles"/>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div>
      <el-dialog
        :visible.sync="addFolder"
        title="New folder"
        width="30%">
        <el-form ref="form" :key="newform" :rules="folder_rules" :model="form" label-position="right" label-width="100px">
          <el-form-item label="Name" prop="name">
            <el-input v-model="form.name"/>
          </el-form-item>
          <el-form-item v-if="manager" label="Department" prop="dept_id">
            <select-department :dept="form.dept" v-model="form.dept_id" @setDepartment="form.dept_id = $event"/>
          </el-form-item>
          <el-form-item label="Description">
            <el-input
              v-model="form.desc"
              type="textarea"
              placeholder="Please input"
              maxlength="150"
              show-word-limit
            />
          </el-form-item>
          <el-form-item v-if="manager" label="Folder type" prop="docutype_id">
            <el-select v-model="form.docutype_id" :remote-method="getDocutype" :remote="true" filterable clearable placeholder="Select Folder Type">
              <el-option v-for="doc in docu_types" :key="doc.id" :value="doc.id" :label="doc.name">{{ doc.name }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Drive Link">
            <el-switch v-model="form.switch_dlink" @change="updateDlink()"/>
          </el-form-item>

          <el-form-item v-if="form.switch_dlink" label="Drive URL" prop="dlink">
            <el-input
              v-model="form.dlink"
              type="textarea"
              placeholder="Please input"
              maxlength="150"
              show-word-limit
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addFolder = false">Cancel</el-button>
          <el-button type="primary" @click="save('form')">Save</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="addFile"
        title="New File"
        width="30%">
        <el-form ref="form_file" :key="newfile" :rules="file_rules" :model="form_file">
          <el-form-item label="Name" prop="name">
            <el-input v-model="form_file.name"/>
          </el-form-item>
          <el-form-item label="Description">
            <el-input
              v-model="form_file.desc"
              type="textarea"
              placeholder="Please input"
              maxlength="150"
              show-word-limit
            />
          </el-form-item>
          <el-form-item ref="attachment_path" label="Supporting Document" class="job-attach" prop="file" >
            <uploader-component :path.sync="form_file.file" :disabled="editable" class="my-upload-job" @setAttachment="form_file.file = $event" />
          </el-form-item>
          <el-button v-loading="saving" type="primary" @click="saveFile('form_file')">Yes! submit</el-button>
        </el-form>
      </el-dialog>
      <el-dialog
        v-if="previewFile"
        :visible.sync="previewFile"
        :title="file_object.name"
        width="85%"
        top
        custom-class="file-dialog">
        <show-file v-loading="loading" :file="file" :file_object="file_object" />
        <!--      <span slot="footer" class="dialog-footer">-->
        <!--        <el-button @click="previewFile = false">Cancel</el-button>-->
        <!--        <el-button type="primary" @click="previewFile = false">Confirm</el-button>-->
        <!--      </span>-->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import TableView from '@/views/qms/table-view'
import { UploaderComponent } from '../../layout/components'
import ShowFile from '../file-view'
import { QMSDirectory, QMSClause, QMSProcess, QMSFiles, DocuTypes } from '@/api/qms'
import SelectDepartment from '../../layout/components/SelectDepartment'
import { Notification } from 'element-ui'
import { Department } from '../../../api/department'
export default {
  name: 'ListOfFolder',
  components: {
    TableView,
    SelectDepartment,
    ShowFile,
    UploaderComponent
  },
  props: {
    category_id: {
      type: Number,
      require: true,
      default: null
    }
  },
  data() {
    return {
      meta: {
        per_page: 12
      },
      files_meta: {
        per_page: 12
      },
      categories: {
        1: 'PLAN',
        2: 'DO',
        3: 'CHECK',
        4: 'ACT'
      },
      clause_info: 'short description for the clause',
      yearArray: [
        { year: 2020 }
      ],
      visibleNewFolder: true,
      files: [],
      search: '',
      folder_search: '',
      filter_dept: [],
      filter_dept_id: null,
      disableFilter: true,
      docu_types: [],
      docu_type_id: null,
      cnt: 0,
      activeTabName: '',
      activeProcessTab: '4',
      tabs: [],
      processTabs: [],
      titletab: '',
      manager: false,
      filterYear: '',
      loading: false,
      category_load: false,
      saving: false,
      clause_id: 0,
      process_id: 0,
      directories: [],
      selected: {},
      currentDate: new Date(),
      routeName: this.$route.name,
      editable: true,
      addFile: false,
      showTable: false,
      addFolder: false,
      previewFile: false,
      directory_owner: false,
      newform: 0,
      newfile: 0,
      form: {
        name: '',
        desc: '',
        docutype_id: null
      },
      return_op: false,
      form_file: {
        file: '',
        filename: '',
        file_type: 1,
        name: '',
        desc: '',
        directory_id: 0
      },
      folder_rules: {
        name: [
          { required: true, message: 'Please input folder name', trigger: 'blur' },
          { min: 3, message: 'Length should be 3 to 5', trigger: 'blur' }
        ],
        dept_id: [
          { required: true, message: 'Please select a department', trigger: 'blur' }
        ],
        dlink: [
          { required: true, message: 'Please input drive URL', trigger: 'blur' }
        ],
        docutype_id: [
          { required: true, message: 'Please select folder content type', trigger: 'blur' }
        ]
      },
      file_rules: {
        name: [
          { required: true, message: 'Please input folder name', trigger: 'blur' },
          { min: 3, message: 'Length should be 3 to 5', trigger: 'blur' }
        ],
        file: [
          { required: true, message: 'Please Attach file', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    category_id: function(item) {
      this.showTable = false
      this.category_load = true
      this.getAll()
      return item
    },
    filter_dept_id: function(item) {
      this.getDirectory()
      return item
    },
    docu_type_id: function(item) {
      this.getDirectory()
      return item
    }
  },
  created() {
    this.filterYear = this.yearArray[0].year
    this.getAll()
    this.getDepartments()
    this.getDocutype()
  },
  methods: {
    getAll() {
      if (this.$store.getters.views.indexOf('QMS_MANAGER') >= 0) {
        this.manager = true
      }
      if (this.$store.getters.views.indexOf('QMS_AUDITOR') >= 0) {
        this.visibleNewFolder = false
      }
      QMSClause({ category_id: this.category_id }).then(res => {
        this.tabs = res.data.clause
        this.setActiveTabName('' + this.tabs[0].id, 0)
        this.category_load = false
      }).catch()
    },
    getAllFiles() {
      QMSFiles({ page: this.files_meta.page, search: this.search, directory_id: this.selected.id }).then(res => {
        this.files_meta = res.data.meta
        this.files = res.data.file
        this.loading = false
      }).catch()
    },
    getProcess() {
      QMSProcess({ clause_id: this.clause_id, per_page: 999 }).then(res => {
        this.processTabs = res.data.process
        this.setActiveProcessTab((this.processTabs[0].id).toString(), this.processTabs[0].name, 0)
      }
      ).catch()
    },
    getDirectory() {
      QMSDirectory({
        page: this.meta.page,
        year: this.filterYear,
        process_id: this.process_id,
        docu_type_id: this.docu_type_id,
        search: this.folder_search
      }).then(res => {
        this.directories = res.data.directory
        this.meta = res.data.meta
        this.loading = false
      }).catch()
    },
    previewfile(flag, file_object, id) {
      this.file = ''
      this.loading = true
      this.file_object = file_object
      this.getFile(id)
    },
    getFile(id) {
      QMSFiles({ id: id }, 'get').then(res => {
        this.file = res.data.massage
        this.loading = false
        this.previewFile = true
      }).catch()
    },
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var action = 'post'
          if (this.form.id) {
            action = 'put'
          }
          this.form.process_id = this.process_id
          this.form.year = this.filterYear
          if (!this.manager) {
            this.form.dept_id = this.$store.getters.department
            this.form.docutype_id = 4
          }
          if (!this.form.switch_dlink) {
            this.form.dlink = ''
          }
          QMSDirectory(this.form, action).then(res => {
            if (res.data.status === 'success') {
              Notification.success({
                title: 'Success',
                message: 'Folder is successfully created',
                duration: 4 * 1000
              })
              this.getDirectory()
              this.addFolder = false
            }
          }).catch()
        }
      })
    },
    saveFile(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var action = 'post'
          if (this.form_file.id) {
            action = 'put'
          }
          this.saving = true
          this.form_file.directory_id = this.selected.id
          this.form_file.year = this.selected.year
          this.$message.warning('Saving File')
          QMSFiles(this.form_file, action).then(res => {
            if (res.data.status === 'success') {
              Notification.success({
                title: 'Success',
                message: 'File is successfully save',
                duration: 4 * 1000
              })
              this.getAllFiles()
              this.newFile(false)
              this.saving = false
            }
          }).catch()
        }
      })
      // var form_data = new FormData()
      // form_data.append('file-view', this.form.file-view)
    },
    opentable(flag, id, item) {
      if (item.dlink) {
        window.open(item.dlink)
      } else {
        this.cnt++
        this.selected = item
        this.showTable = flag
        this.check_my_folder(item.dept_id)
        this.getAllFiles()
      }
    },
    closeTable(flag) {
      this.cnt--
      this.showTable = flag
    },
    newFile(flag) {
      this.newfile++
      this.addFile = flag
      this.form_file = {
        file: '',
        filename: '',
        file_type: 1,
        name: '',
        desc: '',
        directory_id: 0
      }
    },
    newFolder(flag) {
      this.newform++
      this.form = {
        name: '',
        desc: '',
        dept_id: null,
        dept: {},
        docutype_id: null,
        year: 2020
      }
      this.addFolder = flag
    },
    editFolder(data) {
      var switch_link = false
      if (data.dlink) {
        switch_link = true
      }
      this.form = {
        id: data.id,
        name: data.name,
        desc: data.desc,
        dept_id: data.dept_id,
        dept: data.dept,
        dlink: data.dlink,
        file_count: data.file_count,
        switch_dlink: switch_link,
        docutype_id: data.docutype_id,
        year: 2020
      }
      this.addFolder = true
    },
    editFile(data) {
      this.addFile = true
      this.form_file = {
        id: data.id,
        file: data.file,
        filename: data.filename,
        file_type: 1,
        name: data.name,
        desc: data.desc,
        path: data.path,
        directory_id: data.directory_id
      }
    },
    deleteFolder(file) {
      if (file.file_count > 0) {
        this.$message({
          type: 'warning',
          message: 'Please Empty first the Directory'
        })
      } else {
        this.loading = true
        this.$confirm('This will permanently delete the Directory. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          QMSDirectory(file, 'delete').then(res => {
            if (res.data.message === 'success') {
              Notification.success({
                title: 'Success',
                message: 'File is successfully Deleted',
                duration: 4 * 1000
              })
              this.getDirectory()
              this.loading = false
            }
          }).catch()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          })
          this.loading = false
        })
      }
    },
    deleteFile(file) {
      this.loading = true
      this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        QMSFiles(file, 'delete').then(res => {
          if (res.data.message === 'success') {
            Notification.success({
              title: 'Success',
              message: 'File is successfully Deleted',
              duration: 4 * 1000
            })
            this.getAllFiles()
            this.loading = false
          }
        }).catch()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
        this.loading = false
      })
    },
    setActiveTabName(name, index) {
      this.activeTabName = name
      this.clause_id = name
      this.clause_info = this.tabs[index].desc
      this.getProcess()
    },
    setActiveProcessTab(name, title, index) {
      var check_po = this.check_owner(this.processTabs[index].owner, (this.$store.getters.user.currentUser.personnel) ? this.$store.getters.user.currentUser.personnel.department.id : 0)
      if (this.manager || check_po) {
        this.visibleNewFolder = true
      } else {
        this.visibleNewFolder = false
      }
      this.loading = true
      this.directories = []
      this.activeProcessTab = name
      this.process_id = name
      this.titletab = title
      this.closeTable(false)
      this.getDirectory()
    },
    getDepartments(query) {
      Department({ term: query }, 'all').then(res => {
        this.filter_dept = res.data.departments
      }).catch()
    },
    getDocutype(query) {
      DocuTypes({ term: query }, 'get').then(res => {
        this.docu_types = res.data.docutype
      }).catch()
    },
    updateDlink($event) {
      if (this.form.switch_dlink && this.form.id && this.form.file_count > 0) {
        this.$message({
          type: 'warning',
          message: 'Please Empty first the Directory'
        })
        this.form.switch_dlink = false
      }
    },
    check_my_folder(id) {
      if (((this.$store.getters.user.currentUser.personnel) ? this.$store.getters.user.currentUser.personnel.department.id : 0) === id) {
        this.directory_owner = true
        return this.directory_owner
      }
      if (this.manager) {
        this.directory_owner = true
        return this.directory_owner
      } else {
        this.directory_owner = false
        return this.directory_owner
      }
    },
    check_directory_owner(id) {
      var you = false
      if (((this.$store.getters.user.currentUser.personnel) ? this.$store.getters.user.currentUser.personnel.department.id : 0) === id) {
        you = true
        return you
      }
      if (this.manager) {
        you = true
        return you
      } else {
        return you
      }
    },
    check_owner(array, id) {
      // eslint-disable-next-line no-unused-vars
      var you = false
      array.forEach((data) => {
        if (id === data.dept_id) {
          you = true
        }
      })
      if (you && !this.manager && !(this.$store.getters.views.indexOf('QMS_TOP_MANAGEMENT') >= 0)) {
        this.disableFilter = false
        this.filter_dept_id = id
      } else {
        this.disableFilter = true
        this.filter_dept_id = null
      }
      return you
    }
  }
}
</script>

<style lang="scss">
  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }
  .ssearch {
    width: 120px !important;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }
  .btn-delete {
    color: red !important;
  }
  .content-tabs {
    .el-tabs__content {
      padding: 0 !important;
    }
    .outer-tabs {
      .el-tabs__nav .is-top {
        font-size: 16px;
      }
      .inner-tabs {
        .el-tabs__header{
          min-height: 70vh;
          margin-top: 50px;
        }
      }
    }
  }
</style>
